<template>

    <div @click="openPlayer">
        <video-player ref="previewVideoPlayer"
                      :options="playerOptions"
                      class="player-fit vjs-big-play-centered"
                      disablepictureinpicture>
        </video-player>
    </div>

</template>

<script>

import { videoPlayer } from 'vue-videojs7'

export default {

    components: {
        videoPlayer
    },

    data () {

        return {

            ENV_CloudFront_Legacy_DNS_Name: process.env.MIX_LEGACY_CLOUDFRONT_DNSNAME,
            ENV_CloudFront_DNS_Name: process.env.MIX_CLOUDFRONT_DNSNAME,
            ENV_Thumbnail_Key: process.env.MIX_BASE_THUMBNAIL_KEY

        }
    },

    computed: {

        player () {
            return this.$refs.previewVideoPlayer.player
        },

        playerOptions() {

            return {
                autoplay: true,
                controls: false,
                fluid: true,
                muted: true
            }
        },

    },

    props: [
        'currentlocale',
        'videoSource',
        'is_legacy'
    ],

    methods: {

        playVideo: function (source) {

            if(this.is_legacy) {

                const video = {
                    withCredentials: false,
                    type: 'video/mp4',
                    src: source
                }

                this.player.src(video)
                this.player.controlBar.pictureInPictureToggle.dispose()
                this.player.play()

            } else {

                const video = {
                    withCredentials: false,
                    type: 'application/x-mpegurl',
                    src: source,
                }

                this.player.src(video)
                this.player.controlBar.pictureInPictureToggle.dispose()
                this.player.play()
            }


        },

        openPlayer() {

            this.player.dispose()
            this.$parent.openPlayer()

        }
    },

    mounted () {
        console.log(this.videoSource)
        this.playVideo(this.videoSource)
    }

}

</script>

<style scoped>

.player {
    /* position: absolute !important; */
    width: 100%;
    height: 60%;
}

.vjs-custom-skin {
    height: 60% !important;
}

.vjs-custom-skin /deep/ .video-js {
    height: 60%;
}

.player-fit {
    position: relative !important;
    width: 100% !important;
    height: auto !important;
}

</style>
